import http from './httpService';
import config from './../config.json';

const address = config.api_address + config.api_category;

export const getAllCategories = ({signal}, exceptAndSoOn) => {
    return http.get(`${address}`, {signal, params: {exceptAndSoOn}});
}

export const createCategory = (category, params) => {
    return http.post(`${address}`, category, params);
}

export const setCategoriesPriority = (priorities) => {
    return http.patch(`${address}/priority`, priorities);
}

export const updateCategory = (cid, category, params) => {
    return http.patch(`${address}/${cid}`, category, params);
}

export const deleteCategory = (cid) => {
    return http.delete(`${address}/delete-category/${cid}`);
    
}